import './Panel.css';

import { FormattedMessage, injectIntl } from 'react-intl';

import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { pure } from 'recompose';

const Panel = ({
  header,
  footer,
  double,
  triple,
  children,
  noScroll,
  noLoading,
  shaded,
  loading
}) => (
  <div
    className={cx({
      panel: true,
      double,
      triple,
      loading: loading && !noLoading
    })}
  >
    {loading &&
      !noLoading && (
        <div className="panel__loading">
          <div className="spinner">
            <FormattedMessage id="panel.loading" defaultMessage="Loading..." />
          </div>
        </div>
      )}
    {header && <div className="panel__header">{header}</div>}
    <div
      className={cx({ panel__body: true, shaded })}
      style={{
        overflowY: noScroll ? 'visible' : 'auto'
      }}
    >
      {(!loading || noLoading) && children}
    </div>
    {footer && <div className="panel__footer">{footer}</div>}
  </div>
);

Panel.propTypes = {
  header: PropTypes.element,
  footer: PropTypes.element,
  double: PropTypes.bool,
  triple: PropTypes.bool,
  noScroll: PropTypes.bool,
  shaded: PropTypes.bool,
  loading: PropTypes.bool,
  noLoading: PropTypes.bool,
  intl: PropTypes.object
};

export default pure(injectIntl(Panel));



// WEBPACK FOOTER //
// ./src/components/elements/Panel/index.js